import { Maybe } from 'graphql/jsutils/Maybe';
import { Resource as ResourceType } from '@/generated/contentfulTypes';
import { deepmerge } from '@mui/utils';

import { Icon, Icons } from '@/common/components/Icon/Icon';
import Resource from '@/common/components/Resource/Resource';
import { Box, SxProps, Typography } from '@mui/material';
import {
  styledBenefitItem,
  styledBenefitSectionWrapper,
} from './BenefitSection.styled';
import { PrimaryColors } from '@/common/theme/constants';

interface BenefitsListItemProps {
  item: Maybe<ResourceType>;
  icon: Icons;
  sx?: SxProps;
}

interface BenefitsSectionProps {
  includedBenefits?: Maybe<ResourceType>[];
  excludedBenefits?: Maybe<ResourceType>[];
}

const BenefitsListItem = ({ item, icon, sx }: BenefitsListItemProps) => {
  return (
    <Box sx={deepmerge(styledBenefitItem, sx || {})}>
      <Icon size="10px" icon={icon} />
      <Typography variant="body5">{item && <Resource {...item} />}</Typography>
    </Box>
  );
};

export default function BenefitSection({
  includedBenefits,
  excludedBenefits,
}: BenefitsSectionProps) {
  if (!includedBenefits && !excludedBenefits) return null;

  return (
    <Box sx={styledBenefitSectionWrapper}>
      {excludedBenefits &&
        excludedBenefits.length > 0 &&
        excludedBenefits.map((item, index) => (
          <BenefitsListItem
            key={index}
            item={item}
            icon={Icons.Times}
            sx={{ color: PrimaryColors.concrete }}
          />
        ))}
      {includedBenefits &&
        includedBenefits.length > 0 &&
        includedBenefits.map((item, index) => (
          <BenefitsListItem key={index} item={item} icon={Icons.Checkmark} />
        ))}
    </Box>
  );
}
